import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export const SearchResultsHeader = ({
  totalItemCount,
  query,
}: {
  totalItemCount?: number;
  query?: string | string[];
}) => {
  const t = useTranslations("allContainer");

  const queryString = Array.isArray(query) ? query.join(", ") : query;

  if (totalItemCount === undefined || !queryString) return null;

  return (
    <div
      className="flex flex-col gap-4"
      data-testid={applyDataTestId(pom.searchPage.searchResultsHeader)}
    >
      <h2 className="text-2xl font-semibold">{`${t(
        "youSearchedFor"
      )} "${queryString}"`}</h2>

      {totalItemCount > 0 && (
        <p className="text-base text-[#4B5563] font-normal">
          {totalItemCount} {totalItemCount > 1 ? t("results") : t("result")}{" "}
          {t("found")}.
        </p>
      )}

      {totalItemCount === 0 && (
        <p className="text-base text-[#4B5563]">{t("noResultsFound")}</p>
      )}
    </div>
  );
};